import styled from "styled-components";

interface IconContainerProps {
  color: string;
}

const Container = styled.div`
  padding: 20px;
  display: flex;
  align-items: center;
`;

const IconContainer = styled.div<IconContainerProps>`
  #svgAlert {
    > div {
      display: flex;
    }
  }
  
  svg {
    fill: ${({ color }) => color};
    width: 28px;
    height: 28px;
    margin-right: 16px;
  }
`;

export { Container, IconContainer };